import { useSelector } from 'react-redux';

import type { PlatformRole } from '@src/models/interfaces/platformAccount.interface';
import { type PlatformClaims, resolvePlatformRole } from '@src/packages/utils/access';

interface AccessState {
  user?: {
    access?: { loaded?: boolean; loading?: boolean; data?: { claims?: PlatformClaims } | null };
  };
}

export interface PlatformRoleState {
  role: PlatformRole | null;
  /** True while the ID token claims are still being read. */
  loading: boolean;
}

/** The signed-in user's back-office role, or `null` for anyone who is not platform staff. */
export const usePlatformRole = (): PlatformRoleState => {
  // `loading` is false before the claims fetch starts; only `loaded` proves they were read.
  const loading = useSelector(
    (state: AccessState) => !state.user?.access?.loaded || Boolean(state.user?.access?.loading),
  );
  const claims = useSelector((state: AccessState) => state.user?.access?.data?.claims);

  return { role: resolvePlatformRole(claims), loading };
};
